import React from "react";
import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* 404 Number */}
        <div className="text-9xl font-bold text-gray-300 mb-4">404</div>

        {/* Error Message */}
        <h1 className="text-3xl font-semibold text-gray-800 mb-4">
          {t("notFound.title")}
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          {t("notFound.description")}
        </p>
      </div>
    </div>
  );
};

export default NotFound;
